import React, { useState } from 'react';
import { Image, Modal } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import { SaveAndBackWithOutTempButtons } from 'components/base/BottomStepComponent';
import ContentSections from 'components/base/ContentSections';
import PromptButton, { BUTTON_TYPES } from 'components/base/prompt/BaseButtons';
import AdjustValidationResult from 'components/customerDetail/AdjustValidationResult';
import CreatePointRecordDetail from 'components/pointRecord/CreatePointRecordDetail';
import CreatePointRecordGeneral from 'components/pointRecord/CreatePointRecordGeneral';
import { POINT_RECORD_TYPE } from 'config/CustomEnums';
import { validate } from 'containers/record/pointRecords/CreatePorintRecordValidate';

import CloseIcon from 'assets/images/prompt_close_icon.svg';

const mapPropsToState = (state) => ({
  adjustPointValidationResult:
    state.createPointRecord.adjustPointValidationResult,
  adjustTpeValidationResult: state.createPointRecord.adjustTpeValidationResult,
});

function CreatePointRecordStepTwo({
  adjustPointValidationResult,
  adjustTpeValidationResult,
}) {
  const dispatch = useDispatch();
  const [showAddConfirm, setShowAddConfirm] = useState(false);

  const { getValues, clearErrors, setError } = useFormContext();

  const onClose = () => setShowAddConfirm(false);

  const onConfirm = () => {
    setShowAddConfirm(false);
    dispatch({
      type: 'createPointRecord/adjustPoint',
      payload: {
        values: getValues(),
      },
    });
  };

  const stepChangeAction = (isBack) => {
    if (isBack) {
      dispatch({
        type: 'createPointRecord/stepChange',
        payload: {
          isBack: true,
          step: 1,
          isValid: true,
        },
      });
      return;
    }
    const isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 1,
      isBack,
    });
    if (!isValid) {
      return;
    }
    const values = getValues();
    if (values.pointType !== POINT_RECORD_TYPE.TYPE_ADD) {
      onConfirm();
      return;
    }
    const {
      customer: { pk: customerId },
      points = 0,
      tpe = 0,
    } = values;

    dispatch({
      type: 'createPointRecord/adjustPointValidation',
      payload: {
        customerId,
        points,
        tpe,
        validationFailure: () => setShowAddConfirm(true),
        validationSuccess: () => onConfirm(),
      },
    });
  };

  const firstSection = [
    <CreatePointRecordGeneral />,
    <CreatePointRecordDetail />,
  ];

  return (
    <>
      <ContentSections sections={firstSection} hidePreview={true} />
      <SaveAndBackWithOutTempButtons
        backAction={() => stepChangeAction(true)}
        saveText={'Save'}
        saveAction={() => stepChangeAction(false)}
      />

      <Modal
        show={showAddConfirm}
        onHide={onClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Body className={`base-prompt-container customer-detail-prompt`}>
          <Image
            src={CloseIcon}
            className="base-prompt-close-button customer-detail-prompt-close-button"
            onClick={onClose}
          />

          <label className="customer-detail-modal-title">Reminder</label>

          {adjustPointValidationResult ? (
            <AdjustValidationResult
              adjustValidationResult={adjustPointValidationResult}
            />
          ) : null}
          {adjustTpeValidationResult ? (
            <AdjustValidationResult
              adjustValidationResult={adjustTpeValidationResult}
            />
          ) : null}

          <div className="base-prompt-buttons customer-detail-prompt-buttons">
            <PromptButton
              title="Cancel"
              action={onClose}
              type={BUTTON_TYPES.secondary}
            />
            <PromptButton
              title="Confirm"
              action={onConfirm}
              type={BUTTON_TYPES.main}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default connect(mapPropsToState)(CreatePointRecordStepTwo);
